import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../shared/services/api/api.service';
import { UserSessionStore } from '../../shared/services/user-session.store';
import { UserSession } from '../../core/user/user.model';
import { firstValueFrom } from 'rxjs';
import { ImpersonationService } from '../../shared/services/impersonation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUserService } from '../../shared/services/api/user/api-user.service';

@Component({
  templateUrl: 'impersonate.component.html',
  styleUrls: ['./impersonate.component.scss'],
})
export class ImpersonateComponent implements OnInit {
  loading = false;
  constructor(
    private apiService: ApiService,
    private apiUserService: ApiUserService,
    private sessionStore: UserSessionStore,
    private impersonationService: ImpersonationService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  async ngOnInit() {
    this.impersonationService.setImpersonatedUser('');
    this.loading = true;
    const token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!token) {
      this.loading = false;
      await this.router.navigate(['/login']);
      return;
    }
    localStorage.setItem('api_token', token);

    const body = ['email', 'first_name', 'last_name', 'group_account_id', 'modules', 'id'];
    const user = await firstValueFrom(this.apiUserService.searchUserWithFields(body));
    if (user?.id && user?.modules) {
      const session = new UserSession({
        api_token: token,
        email: user.email,
        first_name: user.firstName,
        last_name: user.lastName,
        group_account_id: user.groupAccountId,
        modules: user.modules,
        id: user.id,
      });
      this.sessionStore.setSession(session);
      this.impersonationService.setImpersonatedUser(user.email);
    }
    this.impersonationService.notifyFinished();
    this.loading = false;
    await this.router.navigate(['/search']);
  }
}
